import { useUserOrganization, useIsAdvisor } from 'hooks/useCurrentUser';

const usePlanType = () => {
  const organization = useUserOrganization();
  const planType = organization?.organization?.plan?.name || '';
  const isAdvisor = useIsAdvisor();

  return { planType, isAdvisor };
};

export default usePlanType;
